<template>
	<div class="row px-3">
	<table class="table table-bordered bg-white table-sm mb-0">
		<tbody>
			<tr>
				<td>
					Nome:<b>{{ item.unidade.nome }}</b>
				</td>
				<td>
					CNPJ:<b>{{ item.unidade.cnpj }}</b>
				</td>
				<td>
					Telefone:<b>{{ item.unidade.telefone }}</b>
				</td>
			</tr>
			<tr>
				<td>
					Público-alvo:<b
						v-for="(publico, i) in item.unidade_acolhimento.publico_alvo"
						:key="i"
						v-html="getPublicoAlvo(publico, $root.arrays.acolhimento_publico_alvo)"
					>
					</b>
				</td>
				<td>
					Natureza:<b>{{
						getValue(item.unidade_acolhimento.natureza, $root.arrays.acolhimento_naturezas)
					}}</b>
				</td>
				<td>
					Número do CADSUAS:<b>{{ item.unidade.cadsuas }}</b>
				</td>
			</tr>
		</tbody>
	</table>
	<div class="card card-body shadow border p-2" :class="col_size">
		<h5 class="m-0">Vagas Disponíveis</h5>
		<h1 :class="getClass(item)">
						{{ item.unidade_acolhimento.vagas_disponiveis < 0 ? 0 : item.unidade_acolhimento.vagas_disponiveis}}
						</h1>
	</div>
	<div class="card card-body shadow border p-2" v-if="item.unidade_acolhimento.vagas_disponiveis < 0" :class="col_size">
		<h5 class="m-0">Vagas Excedentes</h5>
		<h1 :class="getClass(item)">
						{{ item.unidade_acolhimento.vagas_disponiveis * -1 }}
						</h1>
	</div>
	<div class="card card-body shadow border p-2" :class="col_size">
		<h5 class="m-0">Vagas Ocupadas</h5>
		<h1 class="text-primary">
						{{ item.unidade_acolhimento.vagas_ocupadas }}
						</h1>
	</div>
	<div class="card card-body shadow border p-2" :class="col_size">
		<h5 class="m-0">Total de Vagas:</h5>
		<h1> {{ item.unidade_acolhimento.vagas }}</h1>
	</div>
</div>
</template>
<script>
export default {
	props: ["item"],
	data(){return{
		col_size:	'col-md-4'
	}},
	watch:{
		item(){
			this.col_size = this.item.unidade_acolhimento.vagas_disponiveis < 0 ?'col-md-3':'col-md-4';
		}
	},
	mounted(){
		this.col_size = this.item.unidade_acolhimento.vagas_disponiveis < 0 ?'col-md-3':'col-md-4';
	},
	methods: {
		getClass(item) {
			return item.unidade_acolhimento.vagas_disponiveis > 0
				? "text-success"
				: "text-danger";
		},
		getPublicoAlvo(value, array) {
			const result = array.filter((item) => item.id == value);
			return result[0]
				? `<span class="badge bg-light text-dark">${result[0].value}</span>`
				: "";
		},
		getValue(value, array) {
			const result = array.filter((item) => item.id == value);
			return result[0] ? result[0].value : "";
		},
	},
};
</script>
